<template>
    <img src="/images/promo/hero-section/bar-chart.png"
     alt="Bar chart" />
</template>

<script>
export default {};
</script>
